module.exports = __webpack_public_path__ + "static/6-c8d4e6d71df6ce9825373ed7e06675b4.jpeg";